export interface IStationButtonState {
  reservation: IButtonState,
  start: IButtonState,
  stop: IButtonState,
  cancel: IButtonState
}

export interface IButtonState {
  show: boolean;
  disabled: boolean;
}

/** Bottone Info (stati non-azionabili PENDING/PENDING_AUTH): solo spiegazione, nessuna azione. */
export interface IInfoButtonState extends IButtonState {
  reason?: 'starting' | 'auth';
}

export enum CmdButton {
  Reserve,
  CancelReservation,
  StartCharge,
  StopCharge,
  EndSession,
  Login,
  Info,
}